import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Instruction = styled.ol`
    display: flex;
    flex-direction: column;
    list-style: decimal;
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    padding-left: 17px;
    gap: 16px;
`;

export const InstructionItem = styled.li`
    padding-left: 8px;
`;

export const BankList = styled.div`
    flex-wrap: nowrap;
    margin-top: 8px;
`;

export const BankItem = styled.div`
    width: 62px;
    height: 24px;
    margin-right: 4px;
    padding: 6px;
    border-radius: 4px;
    background-color: ${COLORS.BgMain};

    img {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: contain;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        &:last-of-type {
            display: none;
        }
    }
`;

export const SbpLink = styled.a`
    width: 32px;
    height: 24px;
    border-radius: 4px;
    background-color: ${COLORS.BgMain};
    background-image: url('/static/images/icons/hDots.svg');
    background-size: 16px 4px;
    background-position: center;
    background-repeat: no-repeat;
`;
